import { CHARACTER_WHITESPACE } from '../../../../constants/common'
import { EVENT_NAME_FOCUS, EVENT_NAME_INPUT } from '../../../../constants/event'
import { useAnimationFrame } from '../../../../hooks'
import {
  WYSIWYG_EDITOR_DEFAULT_CARET_SCROLL_MARGIN_BOTTOM,
  WYSIWYG_EDITOR_EVENT_NEW_BLOCK,
  WYSIWYG_EDITOR_EVENT_RESIZE_CONTENT,
  WYSIWYG_EDITOR_EVENT_RESIZE_EDITOR,
  WYSIWYG_EDITOR_EVENT_SELECTION_CHANGE,
} from '../../WysiwygEditor.constants'
import {
  scrollWysiwygEditorCaretFromUnderSticky,
  scrollWysiwygEditorCaretIntoView,
  scrollWysiwygEditorElementIntoView,
} from '../../WysiwygEditor.utils.scroll'

// TinyMCE prevents the native caret scrolling on Enter and `autoresize` grows
// the iframe only on keyup, so the outer scroll containers never follow the caret
export function useEditorScrollCaretIntoView({
  caretScrollMarginBottom = WYSIWYG_EDITOR_DEFAULT_CARET_SCROLL_MARGIN_BOTTOM,
  editorRef,
}) {
  function handleScrollCaretFromUnderSticky() {
    const editor = editorRef.current

    if (editor?.hasFocus()) {
      scrollWysiwygEditorCaretFromUnderSticky(editor)
    }
  }

  const [scheduleScrollCaretFromUnderSticky] = useAnimationFrame(
    handleScrollCaretFromUnderSticky
  )

  function setup(editor) {
    function handleNewBlock({ newBlock }) {
      // `ResizeContent` re-runs autoresize without the undo level and the
      // focus() that `execCommand('mceAutoResize')` adds
      editor.fire(WYSIWYG_EDITOR_EVENT_RESIZE_CONTENT)

      scrollWysiwygEditorElementIntoView({
        editor,
        element: newBlock,
        marginBottom: caretScrollMarginBottom,
      })
    }

    function handleResizeEditor() {
      if (editor.hasFocus()) {
        scrollWysiwygEditorCaretIntoView({
          editor,
          marginBottom: caretScrollMarginBottom,
        })
      }
    }

    editor.on(WYSIWYG_EDITOR_EVENT_NEW_BLOCK, handleNewBlock)
    editor.on(WYSIWYG_EDITOR_EVENT_RESIZE_EDITOR, handleResizeEditor)
    editor.on(
      [
        EVENT_NAME_FOCUS,
        EVENT_NAME_INPUT,
        WYSIWYG_EDITOR_EVENT_SELECTION_CHANGE,
      ].join(CHARACTER_WHITESPACE),
      scheduleScrollCaretFromUnderSticky
    )
  }

  return {
    setup,
  }
}
